import React from "react"
import {getLane} from "../../../misc/utils"
import PraeferenzfragenGewichtungQuestionaire from "./PraeferenzfragenGewichtungQuestionaire"

export const praeferenzfragenPrototypes = [{
    "key": "lane",
    "type": "SELECTTREE",
    "label": "Questionaire",
    "size": 6,
    "options": "questionList",
}]

const PraeferenzfragenGewichtungWidget = ({widget}) => {
    const lane = getLane(widget)

    return (
        lane?.children?.map((questionaire) => (
            <PraeferenzfragenGewichtungQuestionaire
                key={questionaire.id}
                questionaire={questionaire}
                widget={widget}
            />
        ))
    )
}

export default PraeferenzfragenGewichtungWidget